export const ckeckTouchSupport = () => 'ontouchstart' in window || window.navigator.maxTouchPoints > 0;
